<div class="container mb-5" style="top: -30px">
  <div class="row justify-content-center">
    <h2 class="text-center mb-0">
      {{ 'byt_home_testimonials' | translate }}
    </h2>
  </div>
</div>
<div class="jumbotron py-5">
  <div class="container mb-5">
    <div
      #trustbox
      class="trustpilot-widget"
      data-locale="de-DE"
      data-template-id="539adbd6dec7e10e686debee"
      data-businessunit-id="5d6e605d545e9b0001d23bb7"
      data-style-height="400px"
      data-style-width="100%"
      data-theme="light"
      data-stars="1,2,3,4,5">
      <a
        href="https://de.trustpilot.com/review/bookyourtrail.com"
        target="_blank"
        rel="noopener"
        >Trustpilot</a
      >
    </div>
  </div>
</div>
